"use client";

// Último recurso: este boundary se activa si el root layout en sí falla. Tiene
// que renderizar su propio <html>/<body> porque al haber crasheado el layout,
// no hay árbol DOM disponible. Mantenelo MINIMAL — sin providers, sin fuentes,
// sin theme; solo HTML/CSS inline para garantizar que aparezca algo.

import { useEffect } from "react";
import { captureError } from "@/lib/observability";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    void captureError(error, {
      source: "boundary.global",
      tags: { digest: error.digest, error_code: "internal", fatal: true },
    });
  }, [error]);

  return (
    <html lang="es-AR">
      <body
        style={{
          fontFamily: "system-ui, sans-serif",
          padding: "2rem",
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#0a0a0a",
          color: "#fafafa",
        }}
      >
        <div
          role="alert"
          style={{
            maxWidth: "32rem",
            textAlign: "center",
            padding: "2rem",
            borderRadius: "0.5rem",
            border: "1px solid rgba(239, 68, 68, 0.3)",
            backgroundColor: "rgba(239, 68, 68, 0.05)",
          }}
        >
          <h1 style={{ fontSize: "1.25rem", margin: "0 0 0.5rem" }}>
            La aplicación crasheó
          </h1>
          <p style={{ fontSize: "0.875rem", margin: "0 0 1.5rem", opacity: 0.7 }}>
            Hubo un error fatal y la app no puede continuar. Probá reintentar; si
            persiste, avisanos.
          </p>
          {error.digest ? (
            <p
              style={{
                fontFamily: "ui-monospace, monospace",
                fontSize: "0.75rem",
                opacity: 0.5,
                margin: "0 0 1rem",
              }}
            >
              Referencia: {error.digest}
            </p>
          ) : null}
          <button
            type="button"
            onClick={reset}
            style={{
              padding: "0.5rem 1rem",
              borderRadius: "0.375rem",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              backgroundColor: "rgba(255, 255, 255, 0.05)",
              color: "inherit",
              cursor: "pointer",
              fontSize: "0.875rem",
            }}
          >
            Reintentar
          </button>
        </div>
      </body>
    </html>
  );
}
